<template>
	<div>
		<div class="right-bar">
			<div data-simplebar class="h-100">
				<div class="rightbar-title d-flex align-items-center p-3">
					<h5 class="m-0 me-2">Настройки</h5>
					<a href="javascript:void(0);" class="right-bar-toggle ms-auto" @click="toggleRightBar()">
						<i class="mdi mdi-close noti-icon"></i>
					</a>
				</div>
				<hr class="m-0" />
				<div class="p-4">
					<h6 class="mb-3">Layout Mode</h6>
					<div class="form-check form-check-inline">
						<input class="form-check-input" type="radio" name="layout-mode" id="layout-mode-light" value="light" v-model="layoutMode" />
						<label class="form-check-label" for="layout-mode-light">Light</label>
					</div>
					<div class="form-check form-check-inline">
						<input class="form-check-input" type="radio" name="layout-mode" id="layout-mode-dark" value="dark" v-model="layoutMode" />
						<label class="form-check-label" for="layout-mode-dark">Dark</label>
					</div>
					<h6 class="mt-4 mb-3 pt-2">Layout Width</h6>
					<div class="form-check form-check-inline">
						<input class="form-check-input" type="radio" name="layout-width" id="layout-width-fuild" value="fluid" v-model="layoutSize" />
						<label class="form-check-label" for="layout-width-fuild">Fluid</label>
					</div>
					<div class="form-check form-check-inline">
						<input class="form-check-input" type="radio" name="layout-width" id="layout-width-boxed" value="boxed" v-model="layoutSize" />
						<label class="form-check-label" for="layout-width-boxed">Boxed</label>
					</div>
					<h6 class="mt-4 mb-3 pt-2">Layout Position</h6>
					<!--
					<h6 class="mt-4 mb-3 pt-2">Topbar Color</h6>
					<div class="form-check form-check-inline">
						<input class="form-check-input" type="radio" name="topbar-color" id="topbar-color-light" value="light" v-model="topbar" />
						<label class="form-check-label" for="topbar-color-light">Light</label>
					</div>
					<div class="form-check form-check-inline">
						<input class="form-check-input" type="radio" name="topbar-color" id="topbar-color-dark" value="dark" v-model="topbar" />
						<label class="form-check-label" for="topbar-color-dark">Dark</label>
					</div>
					-->
					<h6 class="mt-4 mb-3 pt-2 sidebar-setting">Sidebar Size</h6>
					<div class="form-check sidebar-setting">
						<input class="form-check-input" type="radio" name="sidebar-size" id="sidebar-size-default" value="lg" v-model="sidebarSize" />
						<label class="form-check-label" for="sidebar-size-default">Default</label>
					</div>
					<div class="form-check sidebar-setting">
						<input class="form-check-input" type="radio" name="sidebar-size" id="sidebar-size-compact" value="small" v-model="sidebarSize" />
						<label class="form-check-label" for="sidebar-size-compact">Compact</label>
					</div>
					<div class="form-check sidebar-setting">
						<input class="form-check-input" type="radio" name="sidebar-size" id="sidebar-size-small" value="sm" v-model="sidebarSize" />
						<label class="form-check-label" for="sidebar-size-small">Small (Icon View)</label>
					</div>
					<h6 class="mt-4 mb-3 pt-2 sidebar-setting">Sidebar Color</h6>
					<div class="form-check sidebar-setting">
						<input class="form-check-input" type="radio" name="sidebar-color" id="sidebar-color-light" value="light" v-model="sidebar" checked>
						<label class="form-check-label" for="sidebar-color-light">Light</label>
					</div>
					<div class="form-check sidebar-setting">
						<input class="form-check-input" type="radio" name="sidebar-color" id="sidebar-color-dark" value="dark" v-model="sidebar" />
						<label class="form-check-label" for="sidebar-color-dark">Dark</label>
					</div>
					<div class="form-check sidebar-setting">
						<input class="form-check-input" type="radio" name="sidebar-color" id="sidebar-color-colored" value="colored" v-model="sidebar" />
						<label class="form-check-label" for="sidebar-color-colored">Colored</label>
					</div>
				</div>
			</div>
		</div>
		<div class="rightbar-overlay" @click="toggleRightBar()"></div>
	</div>
</template>

<style lang="css" scoped>

</style>

<script>
import lib from '@/lib';

export default {
	name: 'RightBar',
	mixins: lib.mixins,
	props: {},
	data: () => ({
		layoutMode: 'light',
		layoutSize: 'fluid',
		//topbar: 'light',
		sidebar: 'light',
		sidebarSize: 'sm',
	}),
	watch: {
		layoutMode(){
			//this.topbar = this.layoutMode == 'light' ? 'dark' : 'light';
			this.sidebar = this.layoutMode;
			document.body.setAttribute('data-layout-mode', this.layoutMode);
		},
		/*topbar(){
			document.body.setAttribute('data-topbar', this.topbar);
		},*/
		sidebar(){
			document.body.setAttribute('data-sidebar', this.sidebar);
		},
		layoutSize(){
			document.body.setAttribute('data-layout-size', this.layoutSize);
		},
		sidebarSize(){
			document.body.setAttribute('data-sidebar-size', this.sidebarSize);
		},
	},
	methods: {
		toggleRightBar(){
			document.body.classList.toggle('right-bar-enabled');
		},
		
	},
	computed: {},
}
</script>